/**
* Indexing critical/sync scripts
* * * * * * * * * * * *
*/
var init = {};
window.aSync = {};

import '../styles/index.less';

import { $ } from './plugins/globalJquery.js';
$ = ($ == undefined ? jQuery : $);

import * as defaultResets from './plugins/defaultResets.js';
import { waitFor } from './plugins/helpers.js';

import './plugins/icons.js';
import './plugins/imageLoader.js';
import { breakpoints } from './modules/breakpoints.js';
import { accordion_ as accordion } from './modules/accordion.js';
import { sitewide } from './modules/sitewide.js';


/**
* Init critical/sync scripts
* * * * * * * * * * * *
*/
init.sync = function() {
	defaultResets.init();
	breakpoints.init();
	init.icons();
	init.imageLoader();
	accordion.init();
	sitewide.init();
}


/**
* Update breakpoints resize
* * * * * * * * * * * *
*/
breakpoints.switch.device = function(size) {
	// console.log(breakpoints.this);
	$('body').icons.init('.svg-icon');
};

breakpoints.resized = function() {
	$('.load-image').imageLoader.resize();
	// Update aSync functions
	if (typeof aSync.scroller != 'undefined' && aSync.scroller == true) {
		$(window).scroller.resize();
	}
};

breakpoints.switch.orientation = function() {
	// console.log('Orientation switch');
};



/**
* Init icons
* * * * * * * * * * * *
*/
init.icons = function() {
	$('body').icons({
		svg : customData.themePath + '/img/output/sprite.svg',
		offset : 2,
		ajax : true,
		testFallback : false,
		ready: function(prop) {
			// console.log(prop);
		}
	});
	$('body').icons.init('.svg-icon');
}



/**
* Init image loader
* * * * * * * * * * * *
*/
init.imageLoader = function() {
	$('.load-image').imageLoader({
		loader : '<span class="img-loader small"></span>',
		ready: function(prop) {
			// console.log(prop);
		},
		resize: function(prop) {
			// console.log(prop);
		}
	});
}



/**
* Init scroller
* * * * * * * * * * * *
*/
init.scroller = function() {
	$(window).scroller({
		items : function() {
			if (typeof aSync.scrollSitewide != 'undefined') {
				aSync.scrollSitewide.items();
			}
		},
		calculation: function(pos) {
			if (typeof aSync.scrollSitewide != 'undefined') {
				aSync.scrollSitewide.calculation(pos);
			}
		},
		animation: function(pos) {
			if (typeof aSync.scrollSitewide != 'undefined') {
				aSync.scrollSitewide.animation(pos);
			}
		},
		resize: function() {
			if (typeof aSync.scrollSitewide != 'undefined') {
				aSync.scrollSitewide.resize();
			}
		},
	});
}



/**
* Indexing & init non-critical/aSync scripts
* * * * * * * * * * * *
*/
init.aSync = function() {
	initASyncScroll();
	initASyncYoutube();
}

function initASyncScroll() {
	import(
		/* webpackChunkName: "scroll" */
		'./modules/scroll.js'
	).then(module => {
		aSync.scrollSitewide = module.scroll;
		init.scroller();
		$(window).scroller.items()
	}).catch(error => 'An error occurred while loading the component');
}

function initASyncYoutube() {
	$('.youtube-video .play-button').click(function(e) {
		e.preventDefault();
		var $this = $(this).parents('.youtube-video');
		if (!$this.hasClass('loading') && !$this.hasClass('active')) {
			$this.addClass('loading');
			if (typeof aSync.youtube == 'undefined') {
				import(
					/* webpackChunkName: "youtube" */
					'./modules/youtube.js'
				).then(module => {
					aSync.youtube = module.youtube;
					aSync.youtube.play($this);
				}).catch(error => 'An error occurred while loading the component');
			} else {
				aSync.youtube.play($this);
			}
		}
	});
	$('.youtube-video .play-button').hover(function(e) {
		e.preventDefault();
		$(this).closest('.youtube-video').addClass('is-hovered');
	}, function() {
		$(this).closest('.youtube-video').removeClass('is-hovered');
	});
}



/**
* Init Project
* * * * * * * * * * * *
*/
$(function() {
	init.sync();
	init.aSync();
});
